<template>
  <v-btn
    icon
    size="small"
    color="card"
    elevation="8"
    class="captain"
    :class="{ 'captain-selected': isCaptain }"
    @click.stop="captainSelected"
  >
    <v-img
      :src="captain"
      alt="captain"
      width="26"
      height="23"
    />
  </v-btn>
</template>

<script>
import captain from '@/assets/captain.svg';
export default {
  name: 'CaptainBtn',
  data() {
    return {
      captain,
    };
  },
  props: {
    isCaptain: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    captainSelected() {
      this.$emit('captainSelected');
    },
  },
};
</script>

<style scoped>
.captain {
  opacity: 0.5;
}

.captain:hover {
  opacity: 1;
}

.captain-selected {
  opacity: 1;
}
</style>
